import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalBody from '../../components/modals/modalBody';
import {resetApprovalData, setApprovalUI} from '../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import ApprovalTargetCard from '../../components/LomavisPostApproval/components/approvalTargetCard';
import ApprovalFlowCard from '../../components/LomavisPostApproval/components/approvalFlowCard';
import ConfigurationToggle from '../../components/LomavisPostApproval/components/configurationToggle';

import LomavisPostsListPreview from '../../components/LomavisPostApproval/components/postsList';
import { useTranslate } from '@tolgee/react';
import ApprovalMessageCard from '../../components/LomavisPostApproval/components/approvalMessageCard';
import RequestApprovalCard from '../../components/LomavisPostApproval/components/requestAprovalCard';
import { EditorHeader } from '../../components/lomavisCreator/components/sharedComponents';
import { relocatePublishButtons } from '../../components/lomavisCreator/utils/uploadMediaFile';
import {
  CONFIG_SELECT_OPTIONS,
  RIGHT_COLUMN_OPTIONS, STATUS_ACTIVE, STATUS_DONE
} from '../../redux/slices/LomavisPostApproval/constants';
import { Button } from 'react-bootstrap';
import { updatePostApproval } from '../../redux/slices/lomavisCreator/lomavisCreator';
import SimpleBarScrollContainer from '../../components/generic/UIComponents/simpleBarScrollContainer';
import { lomavisShowToastr } from '../../redux/slices/utils/ui/toastr';
import EditorConfirmation from '../../components/lomavisCreator/cards/editorExitConfirmation';
import RightColumnToggle from '../../components/LomavisPostApproval/components/rightColumnToggle/indes';
import CurrentStatusCard from '../../components/LomavisPostApproval/components/approvalCurrentStatus';
import {LomavisTitle1} from "../../components/generic/title/lomavisTitle1";
import {LomavisButtonWithIcon} from "../../components/generic/button/lomavisButtonWithIcon";
import {TOLGEE_CANCEL_OF_ACTIVE_APPROVAL_PROCESS_NOT_ALLOWED} from "../../components/lomavisCreator/config/constants";

const ApprovalModal: React.FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const footerRef = useRef(null);

  const [confirmationModal, setConfirmationModal] = useState(false);

  const {
    data,
    local_states: { selected_config_tab, right_column_options }
  } = useSelector((state: any) => state.lomavisPostApproval);
  const { approval_process } = useSelector(
    (state: any) => state.lomavisCreator
  );

  const initialDataRef = useRef(JSON.parse(JSON.stringify(data)));
  const initialData = initialDataRef.current;

  const [rightMargin, setRightMargin] = useState(0);
  const [canBeUpdated, setCanBeUpdated] = useState(true);

  useEffect(() => {
    if (approval_process) {
      setCanBeUpdated(approval_process.status != STATUS_ACTIVE && approval_process.status != STATUS_DONE);
    }
  }, [approval_process]);

  useEffect(() => {
    relocatePublishButtons({
      footerRef: footerRef,
      setRightMargin: setRightMargin
    });
  }, []);

  const confirmChangesBeforeClose = () => {
    if (approval_process && approval_process.status != STATUS_ACTIVE && approval_process.status != STATUS_DONE) {
      if (JSON.stringify(data) !== JSON.stringify(approval_process)) {
        setConfirmationModal(true);
        return;
      }
    } else {
      if (JSON.stringify(data) !== JSON.stringify(initialData)) {
        setConfirmationModal(true);
        return;
      }
    }

    dispatch(
      setApprovalUI({ key: 'showPostApprovalCreatorModal', value: false })
    );
  };

  const handleDelete = () => {

    if (approval_process || approval_process.status == STATUS_ACTIVE || approval_process.status == STATUS_DONE) {

      if (approval_process) {
        lomavisShowToastr(t(TOLGEE_CANCEL_OF_ACTIVE_APPROVAL_PROCESS_NOT_ALLOWED), 'error');
      }
        return;
    }

    dispatch(
        setApprovalUI({ key: 'showPostApprovalCreatorModal', value: false })
    );
    dispatch(updatePostApproval(null));
    dispatch(resetApprovalData());

    lomavisShowToastr(t('lomavisPostApproval.data.deleted'), 'success');
  }

  return (
    <div className="w-100 h-100">
      <EditorConfirmation
        handleClose={() => {
          setConfirmationModal(false);
        }}
        handleClear={() => {
          setConfirmationModal(false);
          dispatch(
            setApprovalUI({
              key: 'showPostApprovalCreatorModal',
              value: false
            })
          );
        }}
        show={confirmationModal}
      />
      <ModalBody onClose={() => confirmChangesBeforeClose()}>

        <div className="d-flex flex-column w-100 vh-100">
          {/* Top header - always visible */}
          <div className={"flex-shrink-0 mb-2"}>
            <EditorHeader>
              <div className="d-flex flex-fill align-items-center h-100 main_editor justify-content-between">
                <div><LomavisTitle1 text={t('lomavisPostApproval.approvalModal')}></LomavisTitle1></div>
                <div>
                  <LomavisButtonWithIcon
                      iconClass="fa-duotone fa-trash"
                      text={t('lomavisPostApproval.requestApproval.delete')}
                      onClickHandler={handleDelete}
                      variant="secondary"
                      size="sm"
                  />
                </div>
              </div>
            </EditorHeader>
          </div>

          {/* Scrollable middle content */}
            <div className="d-flex flex-column flex-grow-1 overflow-auto px-3">
              <div className="d-flex flex-row flex-grow-1 gap-2">
                <div className="col-6 bg-white rounded p-5">
                  <div className="mb-10">
                    <ConfigurationToggle />
                  </div>
                  <div className="mt-4" />
                  {selected_config_tab === CONFIG_SELECT_OPTIONS.CONFIG && (
                      <>
                        <ApprovalFlowCard />
                        <div className="mt-4" />
                        <ApprovalTargetCard />
                        <div className="mt-4" />
                        <ApprovalMessageCard />
                      </>
                  )}

                  {selected_config_tab === CONFIG_SELECT_OPTIONS.POST && (
                      <LomavisPostsListPreview
                          posts={[
                            {
                              image: 'https://picsum.photos/200/300',
                              text: 'Post text goes here test new test',
                              platforms: ['facebook', 'instagram'],
                              date: '2021-10-10'
                            }
                          ]}
                      />
                  )}
                </div>

                <div className="col-6 bg-white rounded p-5 d-flex flex-column">
                  <div className="mb-10">
                    <RightColumnToggle />
                  </div>

                  {right_column_options === RIGHT_COLUMN_OPTIONS.RIGHT_COLUMN_USERS && (
                      <div className="w-100">
                        <RequestApprovalCard />
                      </div>
                  )}

                  {right_column_options === RIGHT_COLUMN_OPTIONS.RIGHT_COLUMN_PROGRESS && (
                      <div className="w-100 d-flex flex-column flex-grow-1">
                        <CurrentStatusCard />
                      </div>
                  )}
                </div>
              </div>
            </div>



          {/* Sticky footer - always visible */}
          <div className={"flex-shrink-0 my-2 mb-6"}>
            <div
                ref={footerRef}
                style={{ zIndex: 100, height: '60px' }}
                className="w-100 d-flex justify-content-end gap-3 align-items-center bg-white rounded py-2 px-3 border-top"
            >
              <Button onClick={() => confirmChangesBeforeClose()} variant="secondary" size="sm">
                {t('lomavisPostApproval.requestApproval.cancel')}
              </Button>

              <Button
                  style={{ marginRight: rightMargin + 'px' }}
                  onClick={() => {


                    // Do not update data for running approval processes
                    if (canBeUpdated) {
                      lomavisShowToastr(t('lomavisPostApproval.data.saved'), 'success');
                      dispatch(updatePostApproval(data));
                    }

                    dispatch(
                        setApprovalUI({
                          key: 'showPostApprovalCreatorModal',
                          value: false
                        })
                    );
                  }}
                  variant="primary"
                  size="sm"
              >
                {canBeUpdated ? t('lomavisPostApproval.requestApproval.send'): t('lomavisPostApproval.requestApproval.close')}
              </Button>
            </div>
          </div>

        </div>


      </ModalBody>
    </div>
  );
};

export default ApprovalModal;
